import React, { useState, useEffect } from 'react';
import StatsCard from '../components/StatsCard';
import ChartSection from '../components/ChartSection';
import { MessageSquare, Trophy, Users, ShieldCheck } from 'lucide-react';
import { DashboardService } from '../services/dashboard.service';
import toast from 'react-hot-toast';

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOverview = async () => {
      try {
        const res = await DashboardService.getOverview();
        if (res) {
          setData(res);
        }
      } catch (error) {
        toast.error('Failed to load dashboard overview');
      } finally {
        setLoading(false);
      }
    };
    fetchOverview();
  }, []);

  if (loading) {
    return (
      <div className="page-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F97316]"></div>
      </div>
    );
  }

  return (
    <>
      <div className="page-header">
        <h1>Dashboard Overview</h1>
      </div>
      <div className="stats-grid">
        <StatsCard
          icon={MessageSquare}
          title="Inquiries"
          value={String(data?.inquiries?.total || 0).padStart(2, '0')}
          growth={`+${data?.inquiries?.recent_week || 0} this week`}
          growthLabel="Recently added"
        />
        <StatsCard
          icon={Trophy}
          title="Affiliated Tournament"
          value={String(data?.tournaments?.total || 0).padStart(2, '0')}
          growth={`Next month: ${data?.tournaments?.upcoming_next_month || 0}`}
          growthLabel="Upcoming"
        />
        <StatsCard
          icon={Users}
          title="Players"
          value={String(data?.players?.total || 0).padStart(2, '0')}
          growth={`Active: ${data?.players?.active || 0}`}
          growthLabel="Registration"
        />
        <StatsCard
          icon={ShieldCheck}
          title="Committee Members"
          value={String(data?.committee?.total || 0).padStart(2, '0')}
          growth="Verified"
          growthLabel="Management"
        />
      </div>
      <ChartSection chartData={data?.chart_data} />
    </>
  );
};

export default Dashboard;
